import EmbeddedFormPage from './EmbeddedFormPage';

const TaxesPage = () => (
  <EmbeddedFormPage
    titleKey="taxes.pageTitle"
    descriptionKey="taxes.description"
    formUrl="https://wonderschool.fillout.com/t/cPQqEbWmbPus"
  />
);

export default TaxesPage;
